import type {FC} from 'react';
import {useEffect} from 'react';
import {Box, Tooltip, Typography} from '@wellstone-solutions/web';
import {useStores} from 'hooks/useStores';
import {NAVIGATION_NAMES} from 'constants/Navigation';
import {SignalsList} from 'modules/signals';

const BETA_COPY = 'Signals is in testing. Your feedback helps train it.';

const DESCRIPTION = [
  'Signals are patterns in Companion activity that may mean someone needs support.',
  'People leave this list on their own once their activity returns to their usual pattern.',
];

export const SignalsPage: FC = () => {
  const {appUIStore} = useStores();

  useEffect(() => {
    appUIStore.setBreadcrumbs([
      {name: NAVIGATION_NAMES.signals, url: '/signals', active: true},
    ]);
  }, [appUIStore]);

  return (
    <Box sx={{p: 2}}>
      <Typography
        variant="h5"
        sx={{
          fontWeight: 700,
          display: 'flex',
          alignItems: 'flex-start',
          gap: 0.75,
          mb: 0.75,
        }}>
        Signals
        <Tooltip title={BETA_COPY}>
          {/* Native span: Tooltip needs a ref its web-wrapped children swallow */}
          <span tabIndex={0} style={{display: 'inline-flex', marginTop: 2}}>
            <Box
              component="span"
              aria-label={`Beta. ${BETA_COPY}`}
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                height: 16,
                px: 0.75,
                borderRadius: 2,
                border: '1px solid',
                borderColor: 'primary.main',
                color: 'primary.main',
                fontSize: 10,
                fontWeight: 700,
                letterSpacing: '0.06em',
              }}>
              BETA
            </Box>
          </span>
        </Tooltip>
      </Typography>

      <Typography
        sx={{
          color: 'text.secondary',
          fontSize: 15,
          lineHeight: 1.5,
          maxWidth: 760,
          mb: 2.25,
        }}>
        {DESCRIPTION[0]}
        <br />
        {DESCRIPTION[1]}
      </Typography>

      <SignalsList />
    </Box>
  );
};
